export interface AppConfig {
  favicon?: string;
  /**
   * O logótipo da marca nas notificações do sistema (a recusa que ainda pode ser
   * liberada), relativo à base da aplicação. Sem ele, a notificação usa o
   * `favicon`.
   */
  notificationIcon?: string;
  splashHtml?: string;
  title?: string;
  isActuar?: boolean;
  isFacilFit?: boolean;
  isEdiz?: boolean;
}

declare global {
  interface Window {
    APP_CONFIG: AppConfig;
    isActuar?: boolean;
    isFacilFit?: boolean;
    isEdiz?: boolean;
  }
}

export function applyAppConfig(config: AppConfig) {
  window.APP_CONFIG = config;
  
  if (config.isActuar !== undefined) {
    window['isActuar'] = config.isActuar;
  }
  
  if (config.isFacilFit !== undefined) {
    window['isFacilFit'] = config.isFacilFit;
  }

  if (config.isEdiz !== undefined) {
    window['isEdiz'] = config.isEdiz;
  }

  if (config.favicon) {
    const favIcon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (favIcon) {
      favIcon.href = config.favicon;
    }
  }

  if (config.splashHtml) {
    document.body.insertAdjacentHTML('afterbegin', config.splashHtml);
    window['LOGO_ANIMATION'] = document.getElementById('LOGO_ANIMATION');
  }

  const normalizedTitle = config.title?.trim();
  if (normalizedTitle) {
    document.title = `${normalizedTitle} - Carregando...`;
  }
}
